import { motion } from "framer-motion";
import { Reveal, Eyebrow } from "./Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "Real Supply",
    text: "Every gram we touch can be weighed, assayed, and traced to a hole in the ground with a name — a cooperative in the Kivus, a pit in the Copperbelt, a loading dock in Dar es Salaam. Supply that cannot be proven is not supply. It is a story.",
  },
  {
    n: "02",
    title: "Verified Counterparties",
    text: "We verify people before we price metal. Beneficial ownership mapped to natural persons, sanctions screened across four regimes, funds confirmed bank-to-bank. The counterparty is the risk — so the counterparty is the process.",
  },
  {
    n: "03",
    title: "Disciplined Execution",
    text: "Mandates in writing. Instruments before movement. Trial lifts before programs. Every transaction closes against an agreed sequence of documents — never against optimism. We don't sell slides. We close.",
  },
];

export const Manifesto = () => (
  <section id="manifesto" data-testid="manifesto-section" className="py-28 lg:py-40 bg-[#0A0A0B] grain relative">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <Eyebrow>The Manifesto</Eyebrow>
      </Reveal>
      <div>
        {CHAPTERS.map((c, i) => (
          <div key={c.n} className={`hairline-t py-14 lg:py-20 grid lg:grid-cols-12 gap-8 items-baseline ${i === CHAPTERS.length - 1 ? "hairline-b" : ""}`} data-testid={`manifesto-chapter-${c.n}`}>
            <div className="lg:col-span-4">
              <Reveal>
                <span className="font-display text-7xl lg:text-9xl font-medium text-outline-gold leading-none select-none" aria-hidden="true">
                  {c.n}
                </span>
              </Reveal>
            </div>
            <div className="lg:col-span-8">
              <Reveal delay={0.1}>
                <h3 className="font-display text-2xl sm:text-3xl lg:text-4xl font-medium tracking-wide text-white uppercase">
                  {c.title}
                </h3>
                <motion.p
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 1, delay: 0.25 }}
                  className="mt-5 text-base lg:text-lg text-zinc-400 leading-relaxed max-w-2xl"
                >
                  {c.text}
                </motion.p>
              </Reveal>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
